import React, { useState } from "react";

import { Button } from "react-bootstrap";
import "./reportGeneration.css";
import Loader from "../../utils/Loader";
import { downloadResponsePDF } from "../services/analyticsService";

const DownloadResponsePdf = ({ patientId, surveyId, respondentDetails }) => {

  const [loading, setLoading] = useState(false);

  const _downloadResponsePDF = async (data) => {
    try {
      const response = await downloadResponsePDF({
        patientId: patientId,
        surveyId: surveyId,
      });

      // Create a Blob from the PDF data
      const blob = await new Blob([response.data], { type: "application/pdf" });
      const url = await window.URL.createObjectURL(blob);

      // Create a temporary link to trigger download
      const a = document.createElement("a");
      a.href = url;
      a.download = `response-${respondentDetails?.name || "patient"}.pdf`; // Set download filename
      document.body.appendChild(a);
      a.click();

      // Cleanup
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (error) {
    }
  };

  const [error, setError] = useState("");
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    await _downloadResponsePDF();
    setLoading(false);
  };

  return (
    <>
      {loading && <Loader />}
      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <Button className="btn filled-btn" onClick={handleSubmit}>
          Generate PDF
        </Button>
      </div>
    </>
  );
};

export default DownloadResponsePdf;
